export const isSignedUrlExpired = (url: string): boolean => {
  if (!url) return true;
  const parsedUrl = new URL(url);
  const amzDate = parsedUrl.searchParams.get("X-Amz-Date");
  const expiresIn = parsedUrl.searchParams.get("X-Amz-Expires");

  if (!amzDate || !expiresIn) return true;
  
  if (amzDate && expiresIn) {
    const start = new Date(
      amzDate.substring(0, 4) +
        "-" +
        amzDate.substring(4, 6) +
        "-" +
        amzDate.substring(6, 8) +
        "T" +
        amzDate.substring(9, 11) +
        ":" +
        amzDate.substring(11, 13) +
        ":" +
        amzDate.substring(13, 15) +
        "Z"
    );

    const expiresSeconds = Number.parseInt(expiresIn, 10);
    const expiryTime = new Date(start.getTime() + expiresSeconds * 1000);

    return new Date() > expiryTime;
  }

  const legacyExpires = parsedUrl.searchParams.get("Expires");
  if (legacyExpires) {
    const expires = Number.parseInt(legacyExpires, 10) * 1000;
    return Date.now() > expires;
  }

  return true;
};
